var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"serie"},[_c('div',{staticClass:"serie__name",on:{"click":_vm.edit}},[_vm._v(_vm._s(_vm.id))]),(_vm.legend)?_c('div',{staticClass:"serie__legend"},[_vm._v(_vm._s(_vm.legend))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }